import(/* webpackMode: "eager", webpackExports: ["default"] */ "/home/u158009827/domains/blueseamarine.in/public_html/.builds/source/bluesea_marine/src/app/services/ServicesPageClient.tsx");
